import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MitigatingAction } from "../../_interfaces/MitigatingAction.model";
import { RepositoryService } from "../../shared/services/repository.service";
import { Router } from '@angular/router';

import { RiskUser } from './../../_interfaces/RiskUser.model';
import { getControlEffectivenessLabel } from 'src/app/_interfaces/ControlEffectivenessEnum';


@Component({
  selector: 'app-mitigating-action-list',
  templateUrl: './mitigating-action-list.component.html',
  styleUrls: ['./mitigating-action-list.component.css']
})
export class MitigatingActionListComponent implements OnInit {
  @Input() public headerText: string;
  @Input() public riskType: number;
  @Input() public mitigatingActions: MitigatingAction[];
  @Output() messageToEmit = new EventEmitter<string>();
  public costBased: boolean;

  public user: RiskUser;


  constructor(private  router: Router,private repository: RepositoryService) {

  }

  ngOnInit() {
    this.costBased = this.riskType === 3;

    this.user = this.repository.GetMyUser();
  }

  public deleteMitigation(mitigationId: number) {
    let riskMitigationUrl: string = `MitigatingActions/${mitigationId}`;
    this.repository.delete(riskMitigationUrl)
      .subscribe(res => {
        // Update the page contents -emit message to parent to refresh page
        this.messageToEmit.emit(`refresh`);
      });
  }
  public getMitigationDetails(id: number) {
    // ToDo - nav to mitigation details dialog
    let mitigationDetailUrl: string = `/myrisks/riskmitigations/${id}`; // ToDo - test this
    this.router.navigate([mitigationDetailUrl]);

}

 getControlEffectivenessLabel(controlEffectivenessValue: number | string): string {
    return getControlEffectivenessLabel(controlEffectivenessValue);
  }
}
